import CloseIcon from 'components/elements/icons/CloseIcon'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'
import styled from 'styled-components'

import { IconProps } from './Icon'

/**
 * ○で囲んだ閉じるアイコン
 */
const SearchIcon: React.FC<IconProps> = (props) => {
  return (
    <StyledCloseIcon>
      <CloseIcon color={CLIENT_SETTINGS.colors.contentBackground} {...props} />
    </StyledCloseIcon>
  )
}

const StyledCloseIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: var(--color-disabled);
  border-radius: 50%;
`

export default SearchIcon
